import { useEffect, useState } from 'react';

/**
 * True below Tailwind's `lg` breakpoint (1024px). Used to switch the planning
 * board's touch interaction model: on mobile a card tap opens the action sheet
 * instead of exposing inline icon controls (which misfire under a finger).
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 1024 : false,
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1023px)');
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);
  return isMobile;
}
